module.exports = __webpack_public_path__ + "static/media/desarrollo3.d8489fbb.png";